module.exports = __webpack_public_path__ + "static/media/h-white.e030ae0c.svg";